var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.search)?_c('search-group-form-page',{key:`edit-query-${_vm.search_id}-${_vm.search.updated_at}`,attrs:{"url":`projects/${_vm.project_id}/searches/${_vm.search_id}`,"resource-name":_vm.resourceName,"item_id":_vm.search_id,"item":_vm.search,"title":_vm.$t('booleanSearch.edit_bool_query'),"is-busy":_vm.isBusy}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }